<p-modal [open]="open" (dismiss)="close()">
  <p-heading slot="header" [size]="'large'" [tag]="'h2'">Edit Remote User Location</p-heading>

  <form class="form" [formGroup]="form" [id]="formId" (ngSubmit)="submit()">
    <p-text-field-wrapper
      *ngrxLet="form.controls.description as control"
      [label]="'Remote User Location Description'"
      [message]="control.errors?.['message'] ?? ''"
      [state]="control.touched && control.errors ? 'error' : 'none'"
    >
      <input type="text" [attr.required]="true" [formControl]="control" />
    </p-text-field-wrapper>
  </form>

  <p-button-group slot="footer">
    <p-button [form]="formId" [loading]="(submitting$ | async) ?? false" [type]="'submit'">
      Save
    </p-button>
    <p-button [iconSource]="'assets/icons/close.svg'" [variant]="'secondary'" (click)="close()">
      Close
    </p-button>
  </p-button-group>
</p-modal>
